
import { login, loginByTg, logout, getInfo, gethomeconfig, getVipInfo } from '@/api/user'
import { drawinfos } from '@/api/safe'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  id: '',
  name: '',
  userInfo: {},
  sysInfo: {},
  vipInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
    state.id = info.id
    state.name = info.nickname
  },
  SET_SYS_INFO: (state, info) => {
    state.sysInfo = info
  },
  SET_VIP_INFO: (state, info) => {
    state.vipInfo = info
  }
}

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { loginname, loginpwd, logintoken, ticket, randstr } = userInfo
    return new Promise((resolve, reject) => {
      login({ loginname, loginpwd, logintoken, ticket, randstr })
        .then(async res => {
          // const token = 'YH17034881841314OVIF2ffM8D7rfrp0'
          const token = res.suid
          await commit('SET_TOKEN', token)
          setToken(token)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginByTelegram({ commit }, payload) {
    return new Promise((resolve, reject) => {
      loginByTg({ initData: payload.initData, hash: payload.hash || '' })
        .then(res => {
          if (!res || !res.suid) {
            reject(new Error('missing suid'))
            return
          }
          commit('SET_TOKEN', res.suid)
          setToken(res.suid)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  changeSuid({ commit }, suid) {
    return new Promise((resolve, reject) => {
      const token = suid
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  },
  // 登出
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      // logout()
      //   .then(() => {
      commit('SET_TOKEN', '')
      removeToken()

      resolve()
      // })
      // .catch(error => {
      //   reject(error)
      // })
    })
  },

  // 获取基本用户信息
  getInfo({ commit, state }, userInfo) {
    return new Promise((resolve, reject) => {
      getInfo(userInfo)
        .then(res => {
          let mons = Math.floor(Number(res.mons) * 100) / 100
          mons = mons.toFixed(2)
          const data = { mons: String(mons), ucode: res.ucode, uname: res.uname, umail: res.email, isagent: res.isagent, setchiptype: res.setchiptype }
          if (!data) {
            reject(new Error('获取基本信息失败，请重新登录'))
          }
          commit('SET_USER_INFO', data)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSysInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      gethomeconfig(state.token)
        .then(async res => {
          const data = res
          document.title = res.logoname
          // setFavicon(res.logourl2, res.logofavicon)
          setManifest(res.logoname, res.logourl2)
          await commit('SET_SYS_INFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
          // resolve(error)
        })
    })
  },
  // 重置token
  resetToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      setToken(token)
      // removeToken()
      resolve()
    })
  },
  // 获取VIP等级
  getVipInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getVipInfo(state.token)
        .then(res => {
          const data = res
          commit('SET_VIP_INFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
function setFavicon(iconUrl, iconUrl2) {
  const linkIcon = document.querySelector('link[rel*="icon"]') || document.createElement('link') // web书签
  linkIcon.rel = 'icon'
  linkIcon.href = iconUrl2
  document.head.appendChild(linkIcon)
  const link = document.querySelector('link[rel*="apple-touch-icon"]') || document.createElement('link') // 影响ios 添加主屏幕
  link.rel = 'apple-touch-icon'
  link.href = iconUrl
  document.head.appendChild(link)
}
function setManifest(name, iconUrl) {
  const manifest = {
    name: name,
    short_name: name,
    start_url: '/',
    display: 'standalone',
    background_color: '#ffffff',
    theme_color: '#000000',
    icons: [
      {
        src: iconUrl,
        sizes: '192x192',
        type: 'image/png'
      },
      {
        src: iconUrl,
        sizes: '512x512',
        type: 'image/png'
      }
    ]
  }
  const link = document.createElement('link')
  link.rel = 'manifest'
  link.href = 'data:application/manifest+json;charset=utf-8,' + encodeURIComponent(JSON.stringify(manifest))
  document.head.appendChild(link)
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
